import { Injectable, signal } from '@angular/core';

export type PortalTheme = 'dark' | 'dark-blue' | 'gray-black';

const ThemeStorageKey = 'portal-theme';
const ThemeClassPrefix = 'theme-';
const AvailableThemes: PortalTheme[] = ['dark', 'dark-blue', 'gray-black'];

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  readonly currentTheme = signal<PortalTheme>('dark-blue');

  constructor() {
    this.applyTheme(this.getSavedTheme(), false);
  }

  setTheme(theme: PortalTheme): void {
    this.applyTheme(theme, true);
  }

  private applyTheme(theme: PortalTheme, persist: boolean): void {
    const body = document.body;
    for (const availableTheme of AvailableThemes) {
      body.classList.remove(`${ThemeClassPrefix}${availableTheme}`);
    }

    body.classList.add(`${ThemeClassPrefix}${theme}`);
    this.currentTheme.set(theme);

    if (persist) {
      localStorage.setItem(ThemeStorageKey, theme);
    }
  }

  private getSavedTheme(): PortalTheme {
    const savedTheme = localStorage.getItem(ThemeStorageKey) as PortalTheme | null;
    return savedTheme && AvailableThemes.includes(savedTheme) ? savedTheme : 'dark-blue';
  }
}
